import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '@services/auth/auth.service';
import { environment } from '@env/environment';
import { EventoCalendario } from '@interfaces/calendario/calendario-interface';
import Swal from 'sweetalert2';

const URL_BACKEND = environment.urlBackend;

@Injectable({
  providedIn: 'root'
})
export class CalendarioService {

  constructor(private authService: AuthService,
              private http: HttpClient

  ) { }

  private async getHeadersWithToken(): Promise<{ headers: HttpHeaders }> {
    const token = await this.authService.loadJwToken();
    return {
      headers: new HttpHeaders({
        'x-token': token
      })
    };
  }

  async postEventoCalendario(data: EventoCalendario): Promise<any> {
    const headers = await this.getHeadersWithToken();
    
    return new Promise((resolve, reject) => {
      this.http.post<any>(`${URL_BACKEND}/eventos-calendario`, data, headers).subscribe({
        next: (resp) => {
          resolve(resp?.response || resp);
        },
        error: (error) => {
          console.error('Error al guardar evento:', error);
          Swal.fire('Error al guardar evento', '', 'error');
          resolve(false);
        }
      });
    });
  }

  // Obtener todos los eventos
  async obtenerEventos(): Promise<EventoCalendario[]> {
    const headers = await this.getHeadersWithToken();
    
    return new Promise((resolve) => {
      this.http.get<{ response: EventoCalendario[] }>(
        `${URL_BACKEND}/eventos-calendario/findAll`, 
        headers
      ).subscribe({
        next: (resp) => resolve(resp?.response || []),
        error: (error) => {
          console.error('Error al obtener eventos:', error);
          Swal.fire('Error al obtener eventos', '', 'error');
          resolve([]);
        }
      });
    });
  }

  // Obtener evento por ID
  async obtenerEventoPorId(_id: string): Promise<EventoCalendario | null> {
    const headers = await this.getHeadersWithToken();
    
    return new Promise((resolve) => {
      this.http.get<{ response: EventoCalendario }>(
        `${URL_BACKEND}/eventos-calendario/findOne/${_id}`, 
        headers
      ).subscribe({
        next: (resp) => resolve(resp?.response || null),
        error: (error) => {
          console.error('Error al obtener evento:', error);
          Swal.fire('Error al obtener evento', '', 'error');
          resolve(null);
        }
      });
    });
  }

  // Eliminar evento
  async deleteEvento(id: string): Promise<boolean> {
    const headers = await this.getHeadersWithToken();
    
    return new Promise((resolve) => {
      this.http.delete(
        `${URL_BACKEND}/eventos-calendario/${id}`, 
        headers
      ).subscribe({
        next: () => resolve(true),
        error: (error) => {
          console.error('Error al eliminar evento:', error);
          Swal.fire('Error al eliminar evento', '', 'error');
          resolve(false);
        }
      });
    });
  }
  
  async updateEvento(id: string, data: EventoCalendario): Promise<any> {
    const headers = await this.getHeadersWithToken();
    return new Promise((resolve, reject) => {
      this.http.put<any>(`${URL_BACKEND}/eventos-calendario/updateOne/${id}`, data, headers).subscribe({
        next: (resp) => {
          resolve(resp?.response || resp);
        },
        error: (error) => {
          console.error('Error al actualizar evento:', error);
          Swal.fire('Error al actualizar evento', '', 'error');
          resolve(false);
        }
      });
    });
  }
}
